import { createContext, useContext } from 'react';

import { AppointmentControlState } from './types';

const AppointmentControlContext =
  createContext<Nullable<AppointmentControlState>>(null);

const useAppointmentControlContext = () => {
  const state = useContext(AppointmentControlContext);

  if (!state) {
    throw new Error(
      'useAppointmentControlContext must be used within an AppointmentProvider'
    );
  }

  return state;
};

export { AppointmentControlContext, useAppointmentControlContext };
